import request from '@/services/request'
import { getApiUrl } from '@/utils/tool'

export async function getBrandInfo(object) {
  return request({
    baseURL: process.env.VUE_APP_BASE_API,
    url: '/brand',
    method: 'post',
    data: object
  })
}

export async function getQuickBar() {
  return request({
    baseURL: getApiUrl(),
    url: '/brand/quick-bar',
    method: 'post'
  })
}

export async function getMarquee() {
  return request({
    baseURL: getApiUrl(),
    url: '/brand/marquee',
    method: 'post'
  })
}

export async function getBanner() {
  return request({
    // cache: {
    //   maxAge: 2 * 60 * 1000,
    //   exclude: {
    //     methods: ['put', 'patch', 'delete']
    //   }
    // },
    baseURL: getApiUrl(),
    url: '/brand/banner',
    method: 'post',
    data: {
      limit: 11
    }
  })
}

export async function getCarousel(object) {
  return request({
    baseURL: process.env.VUE_APP_BASE_API,
    url: '/brand/carousel',
    method: 'post',
    data: object
  })
}

export async function getImage(object) {
  return request({
    baseURL: getApiUrl(),
    method: 'post',
    url: '/brand/get-image',
    data: object
  })
}

export function getBrandGameProviderSidebar(object) {
  return request({
    baseURL: getApiUrl(),
    method: 'post',
    url: '/brand/get-brand-game-provider-sidebar',
    data: object
  })
}
